import * as React from "react";
import { IInitOptions } from "../interfaces/initoptions";
import { getInitOptions } from "../api/initoptions";
import SearchBox from "./searchbox";

const Container = () => {
    return (
        <div className="my-3">
            <div className="facility-search-wrap">
                <SearchBox />
            </div>
        </div>
    );
};

export default Container;
